export const formatCurrency = (number, symbol = "₮") => {
  const formattedNumber = Math.ceil(number)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `${formattedNumber}${symbol}`;
};
